import httpClient from '@/global/httpClient';
import * as apis from '@/constants/api';
import qs from 'qs';

export const updateNicknameGender = (payload) =>
  httpClient.post(apis.UPDATE_NICKNAME_GENDER, payload);
export const updateavatar = (payload) => httpClient.post(apis.UPDATE_AVATAR, payload);
export const updatePassword = (payload) => httpClient.post(apis.UPDATE_PASSWORD, payload);
export const checkMobile = (payload) =>
  httpClient.post(apis.CHECK_MOBILE, qs.stringify(payload), {
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
    },
  });
export const editPassword = (payload) =>
  httpClient.post(apis.EDIT_PASSWORD, qs.stringify(payload), {
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
    },
  });
export const bindEmail = (payload) => httpClient.post(apis.BIND_EMAIL, payload);
//export const bindWechat = (payload) =>
//  httpClient.post(apis.BIND_WECHAT, qs.stringify(payload), {
//    headers: {
//      'Content-Type': 'application/x-www-form-urlencoded',
//    },
//  });
export const updatWechat = (payload) => httpClient.post(apis.UPDATE_WECHAT, payload);
export const unbindWechat = () => httpClient.get(apis.UNBIND_WECHAT);

export const checkBindQrcode = (wechatCode) =>
  httpClient.get(apis.CHECK_BIND_QRCODE + wechatCode, {
    ignore: true,
    ignoreLoading: true,
  });
